<template>
  <div>
    <div class="user_module">
      <div class="module_head">
        <div>
          申报项目（近1月）
        </div>
        <div>
          <img class="more" :src="imgUrl+'icon_more.png'" @click="toPro"/>
        </div>
      </div>
      <div class="module_list_outer">
        <div class="module_list" v-for="(item,index) in xmData" v-show="index<3">
          <div class="cl" style="width: 45%;">
            <div class="cl_col1"  @click="view(item.id,item.xm_level)">
              {{ item.xmmc }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9" >
              申报状态
            </div>
            <div class="stc" :class="{
              stc:item.status===stat3,
              stc1:item.status===stat1,
              stc2:(item.status===stat4 || item.status===stat2)
            }" style="font-size: 14px;">
              {{ item.status }}
            </div>
          </div>
          <div class="cl" style="width: 20%;">
            <div class="q q9" >
              申报时限
            </div>
            <div class="fs lh">
              {{ item.end_time }}
            </div>
          </div>
          <div class="cl" style="width: 20%;">
            <div class="q q9" >
              操作
            </div>

            <div class="operate_outer">
              <span v-if="item.status==='退回修改'" class="btn_edi" @click="showExamAdvice(item.id,item.xmmc,item.sq_date)" style="font-size: 14px;">审核意见</span>
              <span v-if="item.status==='待审核'" class="btn_edi" @click="showExamAdvice(item.id,item.xmmc,item.sq_date)" style="font-size: 14px;">审核意见</span>
              <span v-if="item.status==='通过'" class="btn_edi" @click="showExamAdvice(item.id,item.xmmc,item.sq_date)" style="font-size: 14px;">审核意见</span>
              <span v-if="item.status==='不通过'" class="btn_edi" @click="showExamAdvice(item.id,item.xmmc,item.sq_date)" style="font-size: 14px;">审核意见</span>
              <!-- <span v-if="item.status==='通过'" class="btn_edi" @click="downloadFile(item.id)" style="font-size: 14px;">下载</span> -->
              <!-- <span v-if="item.status==='不通过' && item.xm_level===1" class="btn_edi" @click="downloadFile(item.id,item.xm_level)" style="font-size: 14px;">下载</span> -->
              <span v-if="item.status==='退回修改' || item.status==='正在填写'" class="btn_edi" @click="modify(item.id,item.xm_level)" style="font-size: 14px;">编辑</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="user_module flex">
      <div class="sub_module1">
        <div class="module_head">
          <div>
            我有诉求
          </div>
          <div>
            <img class="more" :src="imgUrl+'icon_view.png'" @click="toAppeal"/>
          </div>
        </div>
        <div class="module_c">
          <div class="item">
            <div class="ch">历年诉求提交</div>
            <div class="num">{{ indexInfo.sq_total }}次</div>
          </div>
          <div class="item">
            <div class="ch">本年诉求提交</div>
            <div class="num">{{ indexInfo.sq_year }}次</div>
          </div>
          <div class="item">
            <div class="ch">本年得到诉求反馈</div>
            <div class="num">{{ indexInfo.sq_complete }}次</div>
          </div>
        </div>
        <div class="module_tj">
          <div class="n">{{question.sq_title}}</div>
          <div v-if="question.refer_time!==null">{{question.refer_time}} 提交 <span class="handle">{{question.statusname}}</span></div>
        </div>
      </div>
      <div class="sub_module2">
        <div class="module_head">
          <div>
            数据调查记录
          </div>
          <div>
            <img class="more" :src="imgUrl+'icon_view.png'" @click="toSurvey"/>
          </div>
        </div>
        <div class="module_c">
          <div class="item" v-if="jjyx==='1'">
            <div class="ch">本年提交产出预测数据</div>
            <div class="num">{{ indexInfo.yc }}次</div>
          </div>
          <div class="item">
            <div class="ch">本年提交产业用地数据</div>
            <div class="num">{{ indexInfo.dc }}次</div>
          </div>
        </div>
        <div class="module_tj" v-if="jjyx==='1'">
          <div>请于本月14日提交下个月预测</div>
        </div>
      </div>
      <div class="sub_module3">
        <div class="module_head">
          <div>
            企业走访
          </div>
          <div>
            <img class="more" :src="imgUrl+'icon_view.png'" @click="toVisit"/>
          </div>
        </div>
        <div class="module_c">
          <div class="item">
            <div class="ch">本年已进行企业走访</div>
            <div class="num">{{ indexInfo.zf }}次</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="1280px">
		  <declare :id="id" :modeD="mode" @emitClose="close" v-if="dialogVisible&&xm_level==1" ></declare>
		  <declare2 :id="id" :modeD="mode" @emitClose="close" v-if="dialogVisible&&xm_level!=1" ></declare2>
    </el-dialog>


    <el-dialog
      title="审核意见"
      :visible.sync="dialogVisibleView"
      width="500px">
      <div class="dialog_head2">
        <div class="tit" v-text="currentItem.xmmc"></div>
        <div class="info"><span class="span" v-text="'提交时间：'+ currentItem.sq_date"></span> </div>
      </div>

      <div class="dialog_main">
        <div class="step_outer" v-if="currentItem.chushen!==null && currentItem.chushen.node!==null">
          <div class="step_cont">
            <div class="row1">
              初审 &nbsp;&nbsp;<span  :class="{
                    txt_color:currentItem.chushen.node.exam_result_name===stat3,
                    txt_color1:currentItem.chushen.node.exam_result_name===stat1,
                    txt_color2:(currentItem.chushen.node.exam_result_name===stat4 || currentItem.chushen.node.exam_result_name===stat2)
                  }">{{ currentItem.chushen.node.exam_result_name }}</span>
            </div>
            <el-divider></el-divider>
            <el-timeline v-for="item in currentItem.chushen.remarks" :key="item.id">
              <el-timeline-item >
                <div :class="{
                    txt_color:item.exam_result_name===stat3,
                    txt_color1:item.exam_result_name===stat1,
                    txt_color2:(item.exam_result_name===stat4 || item.exam_result_name===stat2)
                  }">
                  {{ item.exam_result_name }}
                </div>
                <div class="row2" v-if="item.exam_result===1">审核意见: {{ item.exam_advice }}</div>
                <div class="row3">审核时间:{{ item.sh_time }}</div>

              </el-timeline-item>
            </el-timeline>

          </div>
          <img v-if="currentItem.chushen.node.exam_result_name" class="img" :src="imgUrl+'step_circle.png'"/>
          <img v-else class="img" :src="imgUrl+'step_circle2.png'"/>
        </div>

        <div class="step_outer" v-if="currentItem.zhongshen!==null">
          <div class="step_cont">
            <div class="row1">
              开发区评审 &nbsp;&nbsp;<span  :class="{
                    txt_color:currentItem.zhongshen.node.exam_result_name===stat3,
                    txt_color1:currentItem.zhongshen.node.exam_result_name===stat1,
                    txt_color2:(currentItem.zhongshen.node.exam_result_name===stat4 || currentItem.zhongshen.node.exam_result_name===stat2)
                  }">{{ currentItem.zhongshen.node.exam_result_name }}</span>
            </div>
            <div class="row3">审核时间:{{  currentItem.zhongshen.node.sh_time }}</div>
          </div>
          <img v-if="currentItem.zhongshen.node.exam_result_name" class="img" :src="imgUrl+'step_circle.png'"/>
          <img v-else class="img" :src="imgUrl+'step_circle2.png'"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  created() {
    this.getIndexInfo();
    if(JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"))!=null){
      let corpInfo=JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"));
      this.jjyx=corpInfo.jjyx;
    }

  },
  name: 'usercenter',
  data() {
    return {
      dialogVisibleView:false,
      currentItem: {
        "chushen": {
          "node": {},
          "remarks": []
        },
        "zhongshen": {
          "node":{}
        }
      },
      jjyx:null,
      total: 0,
      xmData: [],
      stat1: '待审核',
      stat2: '退回修改',
      stat4: '不通过',
      stat3: '通过',
      indexInfo: {
        yc: 0,
        dc: 0,
        zf: 0,
        sq_total: 0,
        sq_year: 0,
        sq_complete: 0
      },
      question:{
        sq_title:null,
        refer_time:null,
        statusname:null
      },
      dialogVisible:false,
      id:null,
      xm_level:null,
      mode:''
    }
  },
  methods: {
    async getIndexInfo() {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/tongji/index');
      if(res.data.code!=200){ this.$message.error(res.data.msg); }
      this.indexInfo = res.data.data;
      this.question=res.data.data.quesstion;
      let res02 = await this.$ajax.get(this.bUrl + 'api/portal/zxzj/index?page=1&pagesize=10');
      this.xmData = res02.data.data.list;
      this.total = res02.data.data.total;
    },
    toPro() {
      this.$router.push({name: 'userproject'})
    },
    toAppeal() {
      this.$router.push({name: 'userappeal'})
    },
    toSurvey() {
      this.$router.push({name: 'usersurvey'})
    },
    toVisit() {
      this.$router.push({name: 'uservisit'})
    },
    modify(id, xm_level) {
    	this.xm_level = xm_level;
      this.mode = 'edit';
      this.id = id;
      this.dialogVisible = true;
//    if (xm_level !== 1) {
//      this.$router.push({name: 'declare2', query: {id: id, mode: 'edit'}})
//    } else {
//      this.$router.push({name: 'declare', query: {id: id, mode: 'edit'}})
//    }
    },
    view(id, xm_level) {
    	this.xm_level = xm_level;
      this.mode = 'view';
      this.id = id;
      this.dialogVisible = true;
//    if (xm_level !== 1) {
//      this.$router.push({name: 'declare2', query: {id: id, mode: 'view'}})
//    } else {
//      this.$router.push({name: 'declare', query: {id: id, mode: 'view'}})
//    }
   },
   close(){
    	this.dialogVisible = false
    },
    async showExamAdvice(id,xmmc,sq_date) {
      let res = await this.$ajax.post(this.bUrl + 'api/portal/zxzj/logs', {id});

      this.currentItem = res.data.data;
      let chushen = this.currentItem.chushen;
      if (chushen !== null && chushen.node!=null) {
        if (chushen.node.exam_result === 1) chushen.node.exam_result_name = '退回修改';
        if (chushen.node.exam_result === 2) chushen.node.exam_result_name = '通过';
        if (chushen.node.exam_result === 3) chushen.node.exam_result_name = '不通过';
      }
      if (chushen.remarks.length > 0) {
        chushen.remarks.forEach(item => {
          if (item.exam_result === 1) item.exam_result_name = '退回修改';
          if (item.exam_result === 2) item.exam_result_name = '通过';
          if (item.exam_result === 3) item.exam_result_name = '不通过';
        })
      }

      let zhongshen = this.currentItem.zhongshen;
      if (zhongshen !== null) {
        if (zhongshen.node.exam_result === 1) zhongshen.node.exam_result_name = '退回修改';
        if (zhongshen.node.exam_result === 2) zhongshen.node.exam_result_name = '通过';
        if (zhongshen.node.exam_result === 3) zhongshen.node.exam_result_name = '不通过';
      }
      this.currentItem.xmmc=xmmc;
      this.currentItem.sq_date=sq_date;
      this.dialogVisibleView = true;
    },

    downloadFile(id){
      this.$down.download ('/api/portal/file?id='+id, ".....")
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}


.module_list .xm {
  color: #143367;
  font-weight: bold;
}

.module_list .stc {
  color: #72A757;
}

.module_list .stc1 {
  color: #E38300;
}

.module_list .stc2 {
  color: #C13535;
}

.txt_color {
  color: #72A757;
}

.txt_color1 {
  color: #E38300;
}

.txt_color2 {
  color: #C13535;
}



.module_list .cl {
  margin-right: 24px;
}

.operate_outer span {
  cursor: pointer;
}



.dialog_head2 {
  padding: 10px 0;
  border-bottom: 1px solid #E2E1E2;
  border-top: 1px solid #E2E1E2;
}

.dialog_head2 .tit {
  font-size: 22px;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: #000;
}

.tit01 {
  font-size: 16px;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: #000;
}

.dialog_head2 .info {
  color: rgba(102, 102, 102, .6);
  margin-bottom: 10px;
}

.dialog_head2 .info .span {
  margin-right: 40px;
}

.dialog_head2 .ques {
  line-height: 28px;
}

.dialog_main .step_outer {
  position: relative;
  padding: 20px 20px 0 20px;
  border-left: 3px solid rgba(102, 102, 102, .2);
}

.step_outer img {
  position: absolute;
  left: -9px;
  top: 38px;
}

.dialog_main .step_outer:last-child {
  padding-bottom: 20px;
}

.step_outer .step_cont {
  position: relative;
  border: 1px solid #E2E1E2;
  padding: 15px;
  border-radius: 10px;
}

.step_outer .step_cont .row1 {
  color: #000;
  font-weight: bold;
  margin-bottom: 10px;
}

.step_outer .step_cont .row3 {
  color: rgba(102, 102, 102, .6);
  margin-top: 8px;
  font-size: 13px;
}

.step_cont:before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #fff;
  border: 1px solid #E2E1E2;
  border-right: transparent;
  border-bottom: transparent;
  position: absolute;
  left: -5px;
  top: 20px;
  transform: rotate(-45deg);
}









.user_module.flex {
  display: flex;
}

.sub_module1 {
  padding-right: 25px;
  width: 350px;
}

.sub_module2 {
  padding: 0 25px;
  width: 250px;
  border-left: 1px solid #E1EAFA;
  border-right: 1px solid #E1EAFA;
}

.sub_module3 {
  padding-left: 25px;
  width: 166px;
}

.module_c {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.module_c .ch {
  font-size: 12px;
  color: #999999;
  height: 40px;
}

.module_c .num {
  font-size: 18px;
  color: #143367;
}

.module_c .item {
  margin-right: 32px;
}

.module_c .item:last-child {
  margin-right: 0;
}

.module_tj {
  padding: 14px;
  margin-top: 20px;
  background: #F1F6F9;
  border-radius: 10px;
  border: 1px solid #E1EAFA;
  line-height: 36px;
}

.module_tj .handle {
  float: right;
}

.module_tj .n {
  color: #143367;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/user/usercenter.vue